export default __webpack_public_path__ + "4f0074547200ee86dcb6de8632417e46.png";